import useShopify from '@/hooks/useShopify';
import { StorefrontApiClient } from '@shopify/storefront-api-client';
import { createContext, ReactNode, useContext } from 'react';

type ShopifyProviderProps = {
  // addToCart: (variantId: string, totalInventory: number) => Promise<void>;
  // removeFromCart: (variantId: string) => Promise<void>;
  client: StorefrontApiClient | undefined;
  // goToCheckout: () => void;
  buyNowExpressCheckout: (variantId: string) => Promise<void>;
  fetchUnwrapper: (obj: any) => any;
  // findCollections: () => Promise<any[]>;
  // cart: ShopifyBuy.Cart | undefined;
  // isLoading: boolean;
  // getCartPrice: (cart: any) => string;
};

const Shopify = createContext<ShopifyProviderProps | null>(null);

export function useShopifyProvider() {
  const ctx = useContext(Shopify);
  if (!ctx) throw Error('Need to Set Context Value');
  return ctx;
}

export default function ShopifyProvider({
  children,
}: Readonly<{ children: ReactNode }>) {
  const ctx = useShopify();
  return (
    <Shopify.Provider
      value={{
        ...ctx,
      }}
    >
      {children}
    </Shopify.Provider>
  );
}
